<template>
  <div class="page-width">
    <div class="full_width">
      <div>
        <a
          v-for="(recruiter_name, idx) in recruiter_names"
          :key="idx"
          @click="selectRecruiter(recruiter_name)"
          class="button is-info recruiter_name"
          :class="{ 'is-outlined': recruiter_name != $route.query.recruiter }"
        >
          {{ recruiter_name }}
        </a>
      </div>
      <datatable
        title="Recruiter Report"
        :sorters="sorters"
        @edit_click="edit"
        :response="data"
        :fields="fields"
        :filters="filters"
        :is_createable="false"
        :show_delete="false"
      >
      </datatable>
      <div class="columns">
        <div class="column">
          <p v-if="paidOffers" class="sum_number">
            PAID OFFERS: <b>{{ paidOffers }}</b>
          </p>
          <p v-if="paidOffers && potentialFees" class="sum_number">
            +
          </p>
          <p v-if="potentialFees" class="sum_number">
            POTENTIAL FEES: <b>{{ potentialFees }}</b>
          </p>
          <p v-if="paidOffers && potentialFees" class="sum_number">
            ----------------------
          </p>
          <p v-if="paidOffers && potentialFees" class="sum_number">
            TOTAL FEES: <b>{{ paidOffers + potentialFees }}</b>
          </p>
          <p v-if="sum_paid" class="sum_number">
            PAID TO RECRUITER: <b>{{ sum_paid }}</b>
          </p>
          <p v-if="paidOffers && sum_paid" class="sum_number">
            SUM BALANCE: <b>{{ (Math.round((paidOffers - sum_paid) * 100) / 100).toFixed(2) }}</b>
          </p>
        </div>
        <div class="column is-8">
          <p v-if="isFilteredByRecruiterName" class="sum_number">
            <table class="table">
              <thead>
                <th>Current month</th>
                <th>Previous month</th>
                <th>2 months ago</th>
              </thead>
              <tbody>
                <td><b>{{ paidCurrentMonthsOffers }}</b></td>
                <td><b>{{ paidLastMonthsOffers }}</b></td>
                <td><b>{{ paidLastLastMonthsOffers }}</b></td>
              </tbody>
            </table>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import Datatable from "@/components/Datatable";
import FiltersHelper from "@/classes/filters_helper.js";
import OffersHelper from "@/classes/offers_helper.js";

export default {
  name: "recruiter-report",
  data() {
    let offers_helper = new OffersHelper();
    return {
      filters_helper: new FiltersHelper(),
      greenStatuses: offers_helper.getGreenStatuses(),
      orangeStatuses: offers_helper.getOrangeStatuses(),
      recruiter_names: [],
      sorters: [
        {
						designator: 'start_date',
						value: 'id'
		    },
        {
          designator: 'desc created_at',
          value: '-created_at'
        },
        {
          designator: 'created_at',
          value: 'created_at'
        },
        {
          designator: 'payment_date',
          value: 'payment_date'
        },
			],
      fields: [
        {
          name: "position title",
          value: "offer.position_title",
        },
        {
          name: "Applicant Name",
          value: "offer.applicant_name",
          component: "LinkEntity",
          component_data_path: "offer",
          additional_data: {
            resource_type: "Offer",
          },
        },
        {
          name: "Recruiter",
          value: "recruiter_name",
        },
        {
          name: "Amount",
          value: "offer_payment",
        },
        {
          name: "Expenses",
          value: "expenses_sum",
        },
        {
          name: "Percentage",
          value: "fee",
          component: "Field",
          additional_data: {
            value_path: "fee",
            resource_type: "RecruiterPayment",
            field_type: "input",
          },
        },
        {
          name: "Amount to pay",
          value: "amount_to_pay",
        },
        {
          name: "Status",
          component_data_path: "offer",
          component: "OfferStatus",
        },
        {
          name: "Created At",
          value: "created_at",
        },
        {
          name: "Payment Date",
          value: "payment_date",
        },
        {
          name: "Start Date",
          value: "start_date",
        },
      ],
      filters: [
        {
          type: "multiple",
          designator: "offer_statuses",
          options: offers_helper.getFiltersOptions(),
        },
        {
          type: "date-range",
          label: "Payment Between",
          designator: "payment_between",
        },
      ],
      data: [],
      sum_paid: undefined,
    };
  },
  computed: {
    paidOffers () {
      return this.data.filter(e => this.greenStatuses.includes(e.offer.status)).reduce((acc, curr) => acc + curr.amount_to_pay, 0)
    },
    paidCurrentMonthsOffers () {
      return this.data.filter(e => this.greenStatuses.includes(e.offer.status)).filter(this.currentMonthFilter).reduce((acc, curr) => acc + curr.amount_to_pay, 0)
    },
    paidLastMonthsOffers () {
      return this.data.filter(e => this.greenStatuses.includes(e.offer.status)).filter(this.lastMonthFilter).reduce((acc, curr) => acc + curr.amount_to_pay, 0)
    },
    paidLastLastMonthsOffers () {
      return this.data.filter(e => this.greenStatuses.includes(e.offer.status)).filter(this.lastLastMonthFilter).reduce((acc, curr) => acc + curr.amount_to_pay, 0)
    },
    potentialFees () {
      return  this.data.filter(e => this.orangeStatuses.includes(e.offer.status)).reduce((acc, curr) => acc + curr.amount_to_pay, 0)
    },
    sumFees() {
      return this.data.reduce((acc, curr) => acc + curr.amount_to_pay, 0)
    },
    isFilteredByRecruiterName () {
      return this.$route.query.recruiter || false
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.setRecruitersName();
      this.setRecruiterReportData();
    },
    setRecruitersName() {
      this.$network_utils.getListOfRecruiterNames().then((response) => {
        this.recruiter_names = response.map((i) => i.recruiter_name);
      });
    },
    currentMonthFilter(offer) {
      return !this.$moment().startOf('month').isAfter(this.$moment(offer.payment_date, "DD/MM/YYYY"))
    },
    lastMonthFilter(offer) {
      const start = this.$moment().subtract(1, 'month').startOf('month')
      const end = this.$moment().subtract(1, 'month').endOf('month')
      return this.$moment(offer.payment_date, "DD/MM/YYYY").isBetween(start, end)
    },
    lastLastMonthFilter(offer) {
      const start = this.$moment().subtract(2, 'month').startOf('month')
      const end = this.$moment().subtract(2, 'month').endOf('month')
      return this.$moment(offer.payment_date, "DD/MM/YYYY").isBetween(start, end)
    },
    setRecruiterReportData() {
      const sort = this.$route.query.sort == 'payment_date'
      this.$network_utils
        .getRecruiterFees({
          ...this.filters_helper.getServerCallFilters(this.filters),
          payment_start: this.$route.query.payment_between_start,
          payment_end: this.$route.query.payment_between_end,
          recruiter_name: this.$route.query.recruiter,
          ...( !sort && { sort: this.$route.query.sort }),
          ...( sort && { sort_payment_date: '-true' })
        })
        .then((response) => {
          this.data = response
            .map((recruiter_fee) => {
              recruiter_fee.offer_payment = this.$offers_helper.getPayment(
                recruiter_fee.offer,
                false
              );
              recruiter_fee.start_date = this.$moment(recruiter_fee.offer.start_date).format("DD/MM/YYYY");
              recruiter_fee.created_at = this.$moment(recruiter_fee.created_at).format("DD/MM/YYYY");
              recruiter_fee.payment_date = this.$moment(recruiter_fee.offer.payment_date).format("DD/MM/YYYY");
              recruiter_fee.amount_to_pay =
                (recruiter_fee.offer_payment - recruiter_fee.expenses_sum) *
                (recruiter_fee.fee / 100);
              return recruiter_fee;
            })
            if (!this.$route.query.sort || this.$route.query.sort == 'id') {
              this.data = this.data.sort((a, b) => new Date(b.offer.start_date) - new Date(a.offer.start_date))
            }
        });
      this.$network_utils
        .getRecruiterPayments({ recruiter_name: this.$route.query.recruiter })
        .then((response) => {
          this.sum_paid = 0;
          response.forEach((recruiter_payment) => {
            this.sum_paid += parseInt(recruiter_payment.amount);
          });
        });
    },
    selectRecruiter(recruiter_name) {
      let query = { recruiter: recruiter_name };
      if (this.$route.query.recruiter == recruiter_name) {
        query.recruiter = undefined;
      }
      this.$router.push({ name: this.$route.name, query });
    },
    edit(data) {
      this.createModal({
        component_name: "OfferForm",
        modal_title: `${data.recruiter_name} - ${data.offer.applicant_name}`,
        data: data.offer,
      });
    },
    ...mapMutations("modals", ["createModal"]),
  },
  components: {
    Datatable,
  },
};
</script>
<style scoped>
.recruiter_name {
  margin-right: 10px;
}
.sum_number {
  margin-bottom: 30px;
}
</style>